<template>
  <div class="container">
    <el-dialog
      width="99%"
      title="拆开未装箱盘记录"
      :visible.sync="printInfoDialogVisible"
      center
      @opened="openedPrintDialog"
      @closed="closedPrintDialog">
      <el-form size="small" @submit.native.prevent inline :rules="printRules" :model="printForm" ref="refPrintForm">
        <el-form-item label="Tracking NO:">
          <el-input
            ref="refTrayNo"
            autocomplete="off"
            clearable
            maxlength="50"
            v-model.trim="printForm.trayNo"
            @keyup.enter.native="handleEnterTrackingNo"
            @clear="clearTrackingNo"
            tabindex="1">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loadingPrint"
            type="primary"
            @click="submitPrintForm">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="printInfoList"
        border
        ref="printInfoTable"
        max-height="400px"
        :header-cell-style="{background: '#0E1C3B', padding: '2px 0', textAlign: 'center', color: 'white', fontSize: '13px'}"
        :cell-style="{background: '#0E1C3B', padding: '2px 0', textAlign: 'center', color: 'white', fontSize: '13px'}">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.infos"
                      border
                      :header-cell-style="{'background-color': '#0E1C3B', padding: '2px 0', color: 'white', textAlign: 'center', fontSize: '13px'}"
                      :cell-style="{background: '#0E1C3B', padding: '2px 0', color: 'white', textAlign: 'center', fontSize: '13px'}">
              <el-table-column prop="lotNo" label="印章号" width="250">
              </el-table-column>
              <el-table-column prop="count" label="实际数量" width="120">
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="partNo" label="PARTNO" width="180">
        </el-table-column>
        <el-table-column label="订单子批号" width="250" prop="subNo">
        </el-table-column>
        <el-table-column prop="packageType" label="封装名称" width="150"/>
        <el-table-column prop="count" label="实际数量" width="80">
        </el-table-column>
        <el-table-column prop="lotNo" label="印章号" width="150">
        </el-table-column>
        <el-table-column prop="trackingNo" label="Tracking No" width="300">
        </el-table-column>
        <el-table-column prop="binLevel" label="档位" width="100">
        </el-table-column>
        <el-table-column prop="dateCode" label="dateCode" width="150">
        </el-table-column>
        <el-table-column prop="explain" label="失效原因" width="150">
        </el-table-column>
        <el-table-column prop="result" label="结果" width="80">
          <template slot-scope="scope">
            {{scope.row.result ? 'PASSED' : 'FAILED'}}
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="110">
          <template slot-scope="scope">
            {{formatDate(scope.row.updateAt)}}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="medium"
              type="text"
              @click="reprint(scope.row)">
              重新打印
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="printCount"
        :pageSize="printPerpage"
        :current-page.sync="printPage"
        @current-change="onChangePrintPage"
      />
    </el-dialog>

    <el-form @submit.native.prevent class="form" :inline="true" :model="copyLabelForm" :rules="rules"
             ref="refCopyLabelForm">
      <el-form-item label="请扫描要拆箱子的标签:" prop="trackingNo">
        <el-tooltip
          v-model="isShowBigChar"
          placement="bottom-start"
          effect="dark"
          content="大写锁定已打开"
          manual>
          <el-input
            ref="refTrayNo"
            autocomplete="off"
            clearable
            maxlength="50"
            v-model.trim="copyLabelForm.trackingNo"
            @keyup.enter.native="handleEnter"
            @keypress.native="onKeyPress">
          </el-input>
        </el-tooltip>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="loadingMain"
          type="primary"
          @click="submitForm">
          拆箱
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="showHistoryDialog">
          成品盘
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import moment from 'moment';
  import {generateBinLevelValue, printLabel} from '@/utils/label';
  import printInfoListTable from './upPackingListTable';
  import pagination from './pagination';
  import {
    storeStatus,
  } from '@/utils/defines';
  import {
    splitPost,
    casesListGet,
  } from '@/api/prodStorage';
  import {updateLabel} from '@/api/label';

  export default {
    components: {
      printInfoListTable,
      pagination,
    },
    props: {
      machineHandNoArray: Array,
    },
    data() {
      let validateTrackingNo = (rule, value, callback) => {
        const isEmptyValue = value === undefined || (typeof value === 'string' && !value.trim());
        if (isEmptyValue) {
          this.copyLabelForm.trackingNo = '';
          callback(new Error('标签不能为空'));
          return;
        }
        if (!(/^[A-Za-z0-9/$#@-]+$/.test(value))) {
          this.copyLabelForm.trackingNo = '';
          callback(new Error(`${value}标签格式错误`));
          return;
        }
        callback();
      };
      return {
        rules: {
          trackingNo: [{required: true, validator: validateTrackingNo, trigger: 'submit'}],
        },
        copyLabelForm: {
          trackingNo: ''
        },
        printPage: 1,
        printPerpage: 20,
        printCount: 0,
        loadingMain: false,
        isShowBigChar: false,
        printInfoDialogVisible: false,
        printForm: {
          trayNo: undefined,
        },
        searchParams: {
          trayNo: undefined,
        },
        loadingPrint: false,
        printRules: {
          trayNo: [{required: true, validator: validateTrackingNo, trigger: 'submit'}],
        },
        printInfoList: [],
      }
    },
    mounted() {
      this.$refs.refTrayNo && this.$refs.refTrayNo.focus();
      this.scanBoxInfoBarCode();
    },
    computed: {
      printPageCount() {
        return Math.ceil(this.printCount / this.printPerpage);
      },
    },
    methods: {
      handleEnter() {
        this.submitForm();
      },
      scanBoxInfoBarCode() {
        let code = '';
        let nextCode;
        document.onkeypress = (e) => {
          nextCode = e.which;
          if (nextCode !== 13) {
            code += String.fromCharCode(nextCode);
          }
          if (nextCode === 13) {
            if (this.loadingMain) {
            } else if (this.$refs.refTrayNo && this.$refs.refTrayNo.focused) {
            } else {
              this.copyLabelForm.trackingNo = code;
              this.submitForm();
            }
            code = '';
          }
        };
      },
      submitForm() {
        this.$refs.refCopyLabelForm.validate(async (valid) => {
          if (valid) {
            this.splitPost();
          } else {
            this.copyLabelForm.trackingNo = '';
          }
        });
      },
      handleEnterTrackingNo() {
        this.submitPrintForm();
      },
      clearTrackingNo() {
        this.submitPrintForm();
      },
      submitPrintForm() {
        this.$refs.refPrintForm.validate(async (valid) => {
          if (valid) {
            this.printPage = 1;
            this.searchParams = {...this.printForm};
            this.casesListGet();
          }
        });
      },
      showHistoryDialog() {
        this.printPage = 1;
        this.casesListGet();
        this.printInfoDialogVisible = true;
      },
      async updateLabel({id, partNo, partNoSuffix, trackingNo, dateCode, lotNoInfo, binLevel, machineHandNo = undefined}) {
        try {
          await updateLabel({
            labelId: id,
            partNo: partNo + partNoSuffix,
            trackingNo,
            dateCode,
            lotNoInfo: JSON.stringify(lotNoInfo),
            binLevel: Number.parseInt(binLevel, 10),
            machineHandNo,
          });
          this.$message({
            type: 'success',
            message: '更新成功',
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.casesListGet();
        }
      },
      async casesListGet() {
        try {
          const res = await casesListGet({
            page: this.printPage,
            perpage: this.printPerpage,
            status: JSON.stringify([storeStatus.received.val]),
            belongToBox: false,
            trackingNo: this.searchParams.trayNo || undefined,
          });
          const data = res.data;
          this.printInfoDialogVisible = true;
          this.printInfoList = data.records;
          if (data.count !== undefined) {
            this.printCount = data.count;
          }
        } catch (e) {
        } finally {
          this.loadingPrint = false;
        }
      },
      async splitPost() {
        this.loadingMain = true;
        try {
          let {
            trackingNo
          } = this.copyLabelForm;
          const trackingNoArray = trackingNo.split('#');
          const lastChar = trackingNo.substring(trackingNo.length - 1);
          const isBoxLabel = trackingNoArray[trackingNoArray.length - 1].length >= 7 && lastChar === 'B';
          let res;
          if (isBoxLabel) {
            res = await splitPost({
              boxNo: trackingNo
            });
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          } else {
            this.$message({
              type: 'error',
              message: `${trackingNo}标签信息有误，请检查标签`
            });
          }
          this.copyLabelForm.trackingNo = '';
        } catch (e) {
        } finally {
          this.loadingMain = false;
        }
      },
      async onChangePrintPage() {
        this.casesListGet();
      },
      openedPrintDialog() {
        this.$refs.refTrayNo && this.$refs.refTrayNo.focus();
      },
      closedPrintDialog() {
        this.printForm.trayNo = undefined;
        this.$refs.refPrintForm && this.$refs.refPrintForm.clearValidate();
        this.$refs.refSubNo && this.$refs.refSubNo.focus();
      },
      onKeyPress(event) {
        let e = event || window.event;
        let keyCode = e.keyCode || e.which;
        let isShift = e.shiftKey || keyCode === 16 || false; //shift键是否按住
        if (((keyCode >= 65 && keyCode <= 90) && !isShift)
          || ((keyCode >= 97 && keyCode <= 122) && isShift)) {
          this.isShowBigChar = true;
        } else {
          this.isShowBigChar = false;
        }
      },
      formatDate(updateAt) {
        let updateDate = moment.utc(updateAt);
        let isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
        if (isSameYear) {
          return updateDate.local().format("MM/DD HH:mm");
        } else {
          return updateDate.local().format("YYYY/MM/DD HH:mm");
        }
      },
      reprint(row) {
        const {
          productName,
          chipName,
          binLevel,
        } = row;
        let binLevelValue = generateBinLevelValue({productName, chipName, binLevel});
        printLabel({...row, binLevelExplain: binLevelValue, qty: row.count});
      }
    }
  };
</script>
<style lang="less" scoped>
  .container {
    text-align: center;
  }

  .form {
    margin-top: 40px;
  }
  /deep/ .el-table__fixed-right-patch {
    background: #0E1C3B;
    border: none;
  }
</style>
